import {Dates} from '../packages/dates';
import Translations from '../requests/apa/Translator';
import Asset from '../requests/apa/Asset';
import Utils from './Utils';
import UtilsProfile from './Profile';
import store from 'src/store';

const DEFAULT_SEARCHPRIORITY = JSON.stringify({
  search_predictive_quantity: {
      suggests: '1',
      movies: '5',
      series: '5',
      live_channels: '5',
      events: '5',
      genres: '1',
      talents: '5',
      users: '5',
      unavailables: '0'
    },
    search_full_quantity: {
      suggests: '1',
      movies: '40',
      series: '40',
      live_channels: '40',
      events: '40',
      genres: '1',
      talents: '40',
      users: '40',
      unavailables: '0'
    },
    searchPriority: [
      'suggests',
      'movies',
      'series',
      'fox_movie',
      'foxv3_movie',
      'fox_serie',
      'foxv3_serie',
      'hbo_movie',
      'hbo_serie',
      'crackle_movie',
      'crackle_serie',
      'noggin_movie',
      'noggin_serie',
      'live_channels',
      'fox_live_channel',
      'foxv3_live_channel',
      'hbo_live_channel',
      'epgs_future',
      'epgs_now',
      'epgs_past',
      'genres',
      'talents',
      'users'
    ]
  });

const SEARCH_FIELD = Object.freeze({
  Talent: 'TALENT',
  Genre: 'GENRE'
});

const TALENTS = Object.freeze({
  AMCO: 'talents',
  GRACENOTE: 'external_talents'
});

const GRACENOTE = 'gracenote';

class Search {
  static getSearchField() {
    return SEARCH_FIELD;
  }

  static parserFormatTypes(formatType) {
    if (!Array.isArray(formatType) && formatType) {
      return formatType.split(',');
    }
    if (Array.isArray(formatType)) {
      return formatType;
    }
  }

  static getSearchPriority() {

    const externalProvider = Utils.getApaMetadataKey('external_metadata','{}','provider')
    const externalProviderIsEnabled = Utils.getApaMetadataKey('external_metadata','{"enabled": false}','enabled')
    const searchPriority = Utils.getApaMetadataKey('search_priority','DEFAULT_SEARCHPRIORITY');

    const result = searchPriority;

    if (externalProvider === GRACENOTE && externalProviderIsEnabled) {
      result.searchPriority = result.searchPriority.map(obj => {
        return obj === TALENTS.AMCO ? TALENTS.GRACENOTE : obj;
      });
    }

    return result;
  }

  static setBadgeType(type, groupId) {
    const linealChannels = store.getState().linealChannels;
    let badgeType = type;
      if (type && type === "live") {
        if (linealChannels && Array.isArray(linealChannels)) {
          const foundChannel = linealChannels.find(channel => channel.id == groupId);
          if (foundChannel) {
            badgeType = foundChannel.play ? "live_play1" : "live_play0";
          } else {
            badgeType = "live_play0";
          }
        } else {
          badgeType = "live_play0";
        }
      }
    return badgeType;
  }

  static parserData(data, src) {
    Object.keys(data).map(prop => {
      const groups = data[prop];

      if (Array.isArray(groups)) {
        groups
          .filter(obj => obj)
          .map(it => {
            it.src = it.live_enabled == 1 ? `/player/${it.id}` : `${src}/${it.id}`;
            it.cover =
              data.typeCarousel === 'highlight' ? it.image_small : it.image_medium;
            it.provider = it.proveedor_code != 'amco' ? it.proveedor_code : 'default';
            it.format_types = this.parserFormatTypes(it.format_types) || [];
            it.type = it.live_enabled == 1 ? 'live' : 'vod';
            it.badgeType = this.setBadgeType(it.type, it.id);
          });
      }
    });

    return data;
  }

  static orderPriority(suggest) {
    const searchPriority = this.getSearchPriority();

    const founds = {};
    const keys = Object.keys(suggest);
    searchPriority.searchPriority.forEach(it => {
      keys.forEach(_it => {
        if (it == _it) {
          founds[_it] = suggest[_it];
        }
      });
    });
    return founds;
  }

  static getQuantity() {
    /** Para AAF deberá tomarse la llave search_priority.default.search_full_quantity.<nodo> para obtener los quantity de las categorías.
     Ejemplo:
     [Endpoint]/services/search/predictive?value=dead&suggest=1&movies=40&series=40&unavailables=0&live_channels=40&events=40&genres=1&talents=40&users=40&api_version=v5.4&format=json
     */

    const searchPriority = this.getSearchPriority();
    const searchPredictiveQuantity = searchPriority.search_full_quantity
      ? searchPriority.search_full_quantity
      : {};

    if (!UtilsProfile.isSocialConfigEnable()) {
      delete searchPredictiveQuantity.users;
    }

    return searchPredictiveQuantity;
  }

  static modifyType(data, typeCarousel, keyApa) {
    data.typeCarousel = typeCarousel;
    data.keyApa = `predictSearch_${keyApa}_label`;

    return data;
  }

  /* to parser EPG content */
  static parserEPG(data, key, label) {
    data = this.modifyType(data, 'epg_event', key); // return the typeCarousel and keyApa

    Object.keys(data).map((prop, i) => {
      const epg = data[prop];

      if (Array.isArray(epg)) {
        epg.map(it => {
          it.cover = it.ext_eventimage_name || it.channel_image;
          it.date_begin = it.begintime;
          it.date_end = it.endtime;
          it.title = it.title || it.name;
          it.label = this.getDurationDate(label, it.begintime, it.endtime);
          const eventData = JSON.stringify({ event: it });
          it.src = `/epg/${it.group_id}?eventData=${encodeURI(eventData)}`;
          if (it.channel_group && it.channel_group.common) {
            it.provider = it.proveedor_code != 'amco' ? it.proveedor_code : 'default';
            it.format_types = this.parserFormatTypes(
              it.channel_group.common.format_types
            );
            it.type = it.channel_group.common.live_enabled == 1 ? 'live' : 'vod';
          }
        });
      }
    });
  }

  static handlerContent() {
    const users = (data, key) => {
      data = this.modifyType(data, 'user-info', key); // return the typeCarousel and keyApa

      Object.keys(data).map((prop, i) => {
        const users = data[prop];

        if (Array.isArray(users)) {
          users.map(it => {
            it.src = `socialProfile/${it.id}`;
            let socialImage = '';
            if (it && it.metadatas) {
              it.title = it.metadatas.name || '';

              socialImage = `https://graph.facebook.com/${it.metadatas.facebookId}/picture?type=large`;
              const validateImage =
                it.metadatas.facebookId || it.metadatas.facebookID
                  ? socialImage
                  : '';
              it.cover = validateImage;
              const gameId =
                it.games && it.games.userActions
                  ? Object.keys(it.games.userActions)[0]
                  : '0';
              const points = getPoints(it, gameId);
              const level = getLevel(it, gameId);
              const imgStar = `<div class="levels-points_img"><img src=${Asset.get(
                'social_star'
              )} width="100%"/></div><div class="points">Puntos <b>${points}</b></div>`;
              it.label = `<div class="followers">${it.followers} Seguidores </div><div class="level"> Nivel <b>${level}</b></div>${imgStar}`;
            }
          });
        }
      });

      return data;
    };

    const getLevel = (it, id) => {
      const games =
        (it.gamesArray &&
        it.gamesArray.find &&
        it.gamesArray.find(element => {
          return element.id === id;
        })) ||
        null;

      return games && games.level && games.level.number
        ? games.level.number
        : it.metadatas && it.metadatas.levelNumber
          ? it.metadatas.levelNumber
          : '0';
    };

    const getPoints = (it, id) => {
      const games =
        (it.gamesArray &&
        it.gamesArray.find &&
        it.gamesArray.find(element => {
          return element.id === id;
        })) ||
        null;

      return games && games.points
        ? games.points
        : it.metadatas && it.metadatas.points
          ? it.metadatas.points
          : '0';
    };

    const genres = (data, key) => {
      data = this.modifyType(data, 'text', key); // return the typeCarousel and keyApa

      Object.keys(data).map((prop, i) => {
        const genres = data[prop];

        if (Array.isArray(genres)) {
          genres.map(it => {
            it.src = `talent/${SEARCH_FIELD.Genre}/${it.name}/${false}/`;
            it.typeContent = true;
          });
        }
      });

      return data;
    };

    const talents = (data, key) => {
      data = this.modifyType(data, 'user-profile', key); // return the typeCarousel and keyApa

      Object.keys(data).map((prop, i) => {
        const talents = data[prop];

        if (Array.isArray(talents)) {
          talents.map(it => {
            let chunks;
            let lastName;
            let firstName = '';
            if (it.name.split(' ')) {
              chunks = it.name.split(' ');
            }

            if (Array.isArray(chunks)) {
              chunks.map((it, i) => {
                if (i == chunks.length - 1) {
                  lastName = it;
                } else firstName += it;
              });
            }

            const newName = `${lastName} ${firstName}`;

            it.title = it.name;
            it.src = `talent/${it.id}/${newName}/${false}/`;
            it.typeContent = true;
          });
        }
      });

      return data;
    };

    const external_talents = (data, key) => {
      data = this.modifyType(data, 'user-profile', key); // return the typeCarousel and keyApa

      Object.keys(data).map((prop, i) => {
        const talents = data[prop];
        if (Array.isArray(talents)) {
          talents.map(it => {
            let chunks;
            let lastName;
            let firstName = '';
            if (
              it.first_name &&
              typeof it.first_name === 'string' &&
              it.first_name.split(' ')
            ) {
              chunks = it.first_name.split(' ');
            }

            if (Array.isArray(chunks)) {
              chunks.map((it, i) => {
                if (i == chunks.length - 1) {
                  lastName = it;
                } else firstName += it;
              });
            }
            const newName = `${it.last_name ? it.last_name : ''}, ${it.first_name}`;

            it.title = `${it.first_name} ${it.last_name}`;
            it.src = `talent/${it.internal_ids[0]}/${newName}/${false}/`;
            it.typeContent = true;
            it.cover = it.image ? `${it.image}` : null;
          });
        }
      });

      return data;
    };

    const epgs_future = (data, key) => {
      const label = Translations.get('predictSearch_event_future_sublabel', 'Disponible');
      data = this.parserEPG(data, key, label);
      return data;
    };

    const epgs_past = (data, key) => {
      const label = Translations.get('predictSearch_event_past_sublabel', ' ');
      data = this.parserEPG(data, key, label);
      return data;
    };

    const epgs_now = (data, key) => {
      const label = Translations.get('predictSearch_event_now_sublabel', 'Disponible ahora');
      data = this.modifyType(data, 'epg_event', key); // return the typeCarousel and keyApa

      Object.keys(data).map((prop, i) => {
        const epg = data[prop];

        if (Array.isArray(epg)) {
          epg.map(it => {
            it.cover =
              it.ext_eventimage_name && it.ext_eventimage_name !== ''
                ? it.ext_eventimage_name
                : it.channel_image;
            it.src = `/player/${it.group_id}`;

            if (it.channel_group && it.channel_group.common) {
              it.provider =
                it.proveedor_code != 'amco' ? it.proveedor_code : 'default';
              it.format_types = this.parserFormatTypes(
                it.channel_group.common.format_types
              );
              it.type = it.channel_group.common.live_enabled == 1 ? 'live' : 'vod';
              it.title = it.title || it.name;
              it.label = this.getDurationDate(label, it.begintime, it.endtime);
            }
          });
        }
      });

      return data;
    };

    const suggests = (data, key) => {
      data = this.modifyType(data, 'highlight', key); // return the typeCarousel and keyApa

      const src = `/vcard`;
      data = this.parserData(data, src);
      return data;
    };

    const defaultContent = (data, key) => {
      data = this.modifyType(data, 'portrait', key); // return the typeCarousel and keyApa

      const src = `/vcard`;
      data = this.parserData(data, src);

      for (let index = 0; index < Object.entries(data).length; index++) {
        const value = Object.entries(data)[index];
        if (Array.isArray(data[index]) && value) {
          data[index] = value.filter(obj => obj);
        }
      }

      return data;
    };

    return {
      users,
      talents,
      genres,
      defaultContent,
      epgs_future,
      epgs_past,
      epgs_now,
      suggests,
      external_talents
    };
  }

  static parserSections(obj) {
    const parent = { ...obj };

    const parser = {};
    Object.keys(parent).map((prop, i) => {
      const child = parent[prop];

      Object.keys(child).map((__prop, __i) => {
        if (Array.isArray(child[__prop])) parser[prop] = child;
        else {
          const grandSon = child[__prop];

          Object.keys(grandSon).map((keyGrandson, i) => {
            const newProperty = `${prop}_${keyGrandson}`;

            if (!parser[newProperty]) {
              parser[newProperty] = {};
              parser[newProperty][keyGrandson] = grandSon[keyGrandson];
            }
          });
        }
      });
    });

    return parser;
  }

  static handler(obj) {
    const placeholder = '';
    const handle = this.handlerContent(); // Controla contenidos
    const parent = { ...obj };

    Object.keys(parent).map((prop, i) => {
      let child = parent[prop];
      if (typeof handle[prop] === 'function') child = handle[prop](child, prop);
      else child = handle.defaultContent(child, prop);
    });

    return obj;
  }

  static getSuggest(suggest) {
    let sugg = [];

    if (typeof suggest[0] === 'object') {
      if (
        typeof suggest[0] === 'object' &&
        !Array.isArray(suggest[0]) &&
        !Utils.isEmpty(suggest[0])
      ) {
        if (!Array.isArray(suggest[0].common)) {
          sugg.push(suggest[0].common);
          sugg.map(it => {
            it.provider = it.proveedor_code;
            it.type = it.live_enabled == 1 ? 'live' : 'vod';
          });
        } else {
          sugg = suggest[0].common;
          sugg.provider = sugg.proveedor_code;
          sugg.type = sugg.live_enabled == 1 ? 'live' : 'vod';
        }
      }
    }

    return sugg;
  }

  static getDurationDate(label, beginTime, endTime) {
    const dateFormat = 'YYYY/MM/DD HH:mm:ss';

    if (new Dates(beginTime, dateFormat).isValid() && new Dates(endTime, dateFormat).isValid()) {
      const momentBeginTime = new Dates(beginTime, dateFormat);
      const momentEndTime = new Dates(endTime, dateFormat);
      const result = `${label} ${momentBeginTime.format(
        "dddd DD', de' HH:mm"
      )}hs - ${momentEndTime.format('HH:mm')} hs`;
      return result.trim();
    }

    return '';
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/utils/Search.js